import React from 'react';
import { galleryImages, galleryList } from '../../../Data/data';
import GalleryList from '../../../Components/Globals/GalleryList';

const Studio = () => {
    return (
        <div className='flex w-full pb-8 justify-center'>
            <div className='w-full flex flex-col 520:max-w-[500px] max-w-[400px] px-4 520:px-0'>
                <div className='flex text-white py-8 text-2xl font-light uppercase'>
                    Galleries
                </div>

                <div className='flex flex-col text-white pb-8 text-center'>
                    <div className='font-semibold text-xl'>
                        Juli’s Glass Art is available at these galleries:
                    </div>
                    <div>
                        {galleryList.map(item => (
                            <div key={item} className='text-sm'>
                                {item}
                            </div>
                        ))}
                    </div>
                </div>

                <GalleryList items={galleryImages} />
            </div>
        </div>
    )
}

export default Studio